import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../Context";

function Footer() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const [totalPrice, setTotalPrice] = useState(0);
    const [extraPrice, setExtraPrice] = useState([]);
    const social = useRef(null);
    const [visible, setVisible] = useState(false);
    const [display, setDisplay] = useState(false);
    const [fav, setFav] = useState(state.favourite);
    const [portraitPrice, setPortraitPrice] = useState("");

    useEffect(() => {
        let tp = state.fabricPrice + state.cuffPrice + state.monogramPrice + state.pocketPrice + state.contrastPrice + state.stitchPrice + state.tuxedoPrice + state.placketPrice;
        setTotalPrice(tp);
        const extras = [
            { item: "fabric", price: state.fabricPrice },
            { item: "cuff", price: state.cuffPrice },
            { item: "monogram", price: state.monogramPrice },
            { item: "pocket", price: state.pocketPrice },
            { item: "contrast", price: state.contrastPrice },
            { item: "stitch", price: state.stitchPrice },
            { item: "tuxedo", price: state.tuxedoPrice },
            { item: "placket", price: state.placketPrice }
        ].filter(obj => obj.price > 0);
        setExtraPrice(extras);
        if (tp == state.priceFabric) {
            setExtraPrice([]);
        }
        setFav(state.favourite);
        let ep = tp - state.fabricPrice;
        setPortraitPrice(
            <div className="portraitExtra">
                <span className="extraAmount">${state.fabricPrice}</span>
                <span style={{ padding: "0px 2px" }}> + </span>
                <span className="extraAmount" style={{ color: "blue" }}>${ep}</span>
                <span style={{ padding: "0px 2px" }}> = </span>
                <span className="extraAmount">${tp}</span>
            </div>
        );
        console.log(state.fabricShirt)
    }, [state.fabricPattern, state.fabricPrice, state.cuffPrice, state.monogramPrice, state.pocketPrice, state.contrastPrice, state.stitchPrice, state.tuxedoPrice, state.placketPrice]);

    function onSharesClick() {
        if (!visible) {
            setDisplay(true);
            requestAnimationFrame(() => {
                setVisible(true);
            });
        } else {
            setVisible(false);
        }
    }
    function handleTransitionEnd(e) {
        if (e.propertyName !== "opacity") return;
        if (!visible) {
            setDisplay(false);
        }
    }
    function onTileClick(id) {
        dispatch({ type: "SET_FABRIC_VIEW", payload: id })
    }
    function toggleFavourite() {
        let f = !state.favourite;
        state.favourite = f;
        setFav(f);
    }
    function add2Cart() {

    }
    function shareSocial(id) {
        if (id == "link") {
            navigator.clipboard.writeText(window.location.href);
            alert('Page link saved in clipboard successfully!');
        } else if (id == "facebook") {
            let urlToShare = encodeURIComponent(window.location.href);
            let shareText = encodeURIComponent("Some Sharing Text");
            let facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${urlToShare}&quote=${shareText}`;
            window.open(facebookUrl, 'facebook-share-dialog', 'width=626,height=436');
            return false;
        } else if (id == "twitter") {
            const urlToShare = encodeURIComponent(window.location.href);
            const shareText = encodeURIComponent("Some Sharing Text");
            const hashtags = encodeURIComponent('example,hashtag');
            const twitterUrl = `https://twitter.com/intent/tweet?url=${urlToShare}&text=${shareText}&hashtags=${hashtags}`;
            window.open(twitterUrl, 'twitter-share-dialog', 'width=626,height=436');
            return false;
        } else if (id == "whatsapp") {
            const urlToShare = encodeURIComponent(window.location.href);
            const shareText = encodeURIComponent("Some Sharing Text");
            const whatsappUrl = `https://wa.me/?text=${shareText}${urlToShare}`;
            window.open(whatsappUrl, '_blank');
            return false;
        }
    }
    function onExtraPriceClick() {
        dispatch({ type: "SET_SHOW_EXTRA_PAGE", payload: true })
    }
    return (
        <div className="footer">
            <div className="footerTop">
                <div className="fabricName">{state.fabricCategoryTitle}</div>
                <div className="fabricPattern">{state.fabricPattern}</div>
                <div className="itemName" style={{ display: state.orientation == "landscape" ? "flex" : "none" }}>Shirt</div>
                <div className="price" style={{ display: state.orientation == "landscape" ? "flex" : "none" }}>${totalPrice}</div>
                <div onClick={onExtraPriceClick} className="price" style={{ display: state.orientation == "landscape" ? "none" : "flex" }}>
                    {portraitPrice}
                </div>
                <div className="extraAmount" style={{ display: state.orientation == "landscape" ? "flex" : "none" }}>
                    {extraPrice.map((item, index) => (
                        <div key={index} style={{ fontSize: "1cqw" }}>
                            ${item.price} - {item.item}
                        </div>
                    ))}
                </div>
            </div>
            <div className="footerMid">
                <div className="shareBox">
                    <img onClick={toggleFavourite} className="shareIcon" src={fav ? process.env.PUBLIC_URL + "/images/redheart.svg" : process.env.PUBLIC_URL + "/images/heart.svg"} />
                    <img className="shareIcon" src={process.env.PUBLIC_URL + "/images/share.svg"} onClick={onSharesClick} />
                    {display && (
                        <div ref={social} onTransitionEnd={handleTransitionEnd} className={`shareIcons ${visible ? "showShareIcons" : ""}`}>
                            <img onClick={() => { shareSocial("link") }} className="socialIcons" src={process.env.PUBLIC_URL + "/images/link.svg"} />
                            <img onClick={() => { shareSocial("facebook") }} className="socialIcons" src={process.env.PUBLIC_URL + "/images/facebook.svg"} />
                            <img onClick={() => { shareSocial("twitter") }} className="socialIcons" src={process.env.PUBLIC_URL + "/images/twitter.svg"} />
                            <img onClick={() => { shareSocial("whatsapp") }} className="socialIcons" src={process.env.PUBLIC_URL + "/images/whatsapp.svg"} />
                        </div>
                    )}
                </div>
                <div onClick={add2Cart} className="btnAdd2Cart">Add to Cart</div>
            </div>
            <div className="footerBot" style={{ display: state.orientation == "landscape" ? "flex" : "none" }}>
                <img onClick={() => { onTileClick("shirt") }} className="tileImage" src={process.env.PUBLIC_URL + "/fabrics/" + state.fabricCategory + "/" + state.fabricShirt} />
                <img onClick={() => { onTileClick("tile") }} className="tileImage" src={process.env.PUBLIC_URL + "/fabrics/" + state.fabricCategory + "/" + state.fabricTile} />
            </div>
        </div>
    );
}

export default Footer;
